@import '@fontsource-variable/manrope/index.css';

/*
 * index.css is a manifest now.
 *
 * It was 3110 lines and 135 KB in one file, with 1041 rule blocks and 175
 * selectors defined more than once, which is why a small visual change meant
 * reading the whole thing to find which of four `.kanban-board` blocks won.
 *
 * The split below is purely mechanical: the rules are byte-for-byte the same and
 * in exactly the same order, so the cascade is unchanged. Vite inlines these
 * imports at build time. ORDER IS SIGNIFICANT — `responsive.css` and
 * `refinements.css` are late overrides and must stay last.
 *
 * New work should go into a feature stylesheet next to its component
 * (src/styles/<feature>.css, imported from that component) rather than growing
 * these files again.
 */
@import './styles/core/tokens.css';
@import './styles/core/layout.css';
@import './styles/core/dashboard.css';
@import './styles/core/chats.css';
@import './styles/core/warehouse.css';
@import './styles/core/ai.css';
@import './styles/core/integrations.css';
@import './styles/core/overlays.css';
@import './styles/core/responsive.css';
@import './styles/core/deals.css';
@import './styles/core/pricing.css';
@import './styles/core/refinements.css';
